﻿import {translation} from "@2d-front-monorepo/core";
import {MaterialIcon, showErrorDialog} from "@2d-front-monorepo/design-library";
import {CreditCardProvider} from "@2d-front-monorepo/permits-business";
import {JSX, useCallback} from "react";
import {useNavigate} from "react-router";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {reloadPermits} from "../../contexts/PermitsContext";
import {useCreditCardAssignment} from "../../hooks/useCreditCardAssignment";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";

const creditCardProviders: Record<CreditCardProvider, string> = {
	0: "",
	1: "Credit call",
	2: "IECISA",
	3: "Elavon Santander",
	4: "Stripe",
	5: "Moneris",
	6: "Transbank",
	7: "PayU",
	8: "PayPal",
	9: "NiIdea",
	10: "Debit/Credit card",
	11: "MercadoPago",
	13: "Windcave"
};

export default function Payments(): JSX.Element {
	const navigate = useNavigate();
	const {holderData} = usePermits();
	const creditCardPan = holderData.paymentProviders?.creditCardPan ?? "";

	const [currentCardProvider, setCardProvider] = useCreditCardAssignment("payments", []);

	const startRegister = useCallback(async function (): Promise<void> {
		try {
			await setCardProvider();
			await reloadPermits();

			navigate(PrivateRoutes.payments);
		} catch (error) {
			showErrorDialog(error);
		}

	}, [currentCardProvider]);

	return (
		<>
			<h1>{translation(PermitTranslations.payments_page__title)}</h1>
			<hr/>
			<nav>
				<ul className="link-list link-list--flex">
					{currentCardProvider == CreditCardProvider.Undefined ?
						<li>
							<button onClick={startRegister} type="button">
								<MaterialIcon icon="add"/>
								<span>{translation(PermitTranslations.payments_page__add_new_card)}</span>
							</button>
						</li>
						:
						<>
							<li>
								<button type="button" aria-current="true">
									<MaterialIcon icon="credit_card"/>
									<span>{creditCardPan}</span>
									<small>{creditCardProviders[currentCardProvider]}</small>
								</button>
							</li>
							<li>
								<button onClick={startRegister} type="button">
									<MaterialIcon icon="credit_card_gear"/>
									<span>{translation(PermitTranslations.payments_page__change_card)}</span>
								</button>
							</li>
						</>
					}
				</ul>
			</nav>
		</>
	);
}
